import { defineStore } from 'pinia';

export const useErrorsStore = defineStore('errors', {
  state: () => ({
    errors: null as string[]|string|null,
    forceShow: false,
  }),
  actions: {
    setErrors(errors:string[]|string) {
      if (this.errors === null) {
        this.errors = !Array.isArray(errors) ? [errors] : errors;
        return;
      }
      if (Array.isArray(this.errors)) {
        if (Array.isArray(errors)) this.errors.concat(errors);
        else this.errors.push(errors);
        return;
      }
      this.errors = errors;
    },
    closeError() {
      this.errors = null;
      this.forceShow = false;
    }
  }
});
